<template>
	<div>
		<a
			href="#"
			data-reveal-id="createSetupFeesModal"
			class="button secondary expand tiny"
			@click="resetCounter"
		>
			Create
		</a>

		<div
			id="createSetupFeesModal"
			class="reveal-modal text-center small"
			data-reveal
			aria-labelledby="modalTitle"
			aria-hidden="true"
			role="dialog"
		>
			<div class="row">
				<div class="columns">
					<h3 id="modalTitle text-alert">
						This will create new Setup Fees
					</h3>
					<p class="lead">
						This will create new setup fees for every contact who
						doesn't already have one in an order
					</p>
				</div>
			</div>

			<div class="row">
				<div class="columns medium-6">
					<label for="sliceIndex">Start</label>
					<input type="text" v-model.number="sliceIndex" />
				</div>

				<div class="columns medium-6">
					<label for="count">Count</label>
					<input type="text" v-model.number="count" />
				</div>
			</div>

			<div class="row">
				<div class="columns medium-6">
					<label for="inProgramme">In Programme</label>
					<input type="checkbox" v-model="inProgramme" />
				</div>

				<div class="columns medium-6">
					<label for="inCamp">In Camp</label>
					<input type="checkbox" v-model="inCamp" />
				</div>
			</div>

			<div class="row">
				<div class="columns">
					<table class="full-width">
						<thead>
							<th class="text-center">
								<input type="checkbox" @click="selectAll" />
							</th>
							<th>
								Name
							</th>
							<th>
								Setup Fee Paid
							</th>
						</thead>

						<tbody
							v-for="(contact, index) in contactsSliced"
							:key="contact.childId"
						>
							<tr>
								<td class="text-center">
									{{ index }}
									<input
										type="checkbox"
										v-model="selected"
										:value="contact"
									/>
								</td>
								<td>
									{{ contact.childFirstName }}
									{{ contact.childLastName }}
								</td>

								<td class="text-center">
									<i
										class="fal fa-check-square fa-2x"
										v-if="contact.setupFeePaid == 1"
									></i>
									<i
										class="fal fa-times-square fa-2x"
										v-else
									></i>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="row mtl">
				<div class="columns">
					<button
						class="button alert expand"
						:disabled="disabled"
						@click="createNewSetupFees"
					>
						{{ message }}
					</button>
				</div>
			</div>
			<a class="close-reveal-modal" aria-label="Close">&#215;</a>
		</div>
	</div>
</template>

<script>
'use strict';

export default {
	name: 'CreateNewSetupFees',
	data() {
		return {
			loading: false,
			countDownTime: 10,
			counter: 10,
			timer: {},
			selected: [],
			sliceIndex: 0,
			count: 50,
			inProgramme: true,
			inCamp: false
		};
	},

	methods: {
		resetCounter() {
			this.counter = this.countDownTime;
			clearInterval(this.timer);
			this.countdown();
		},

		countdown() {
			this.timer = setInterval(() => {
				if (this.counter > 0) {
					this.counter -= 1;
				} else {
					clearInterval(this.timer);
				}
			}, 1000);
		},
		async createNewSetupFees() {
			this.loading = true;
			await this.$store.dispatch('CREATE_SETUP_FEES', this.selected);
			this.loading = false;
		},
		selectAll() {
			if (this.selected.length > 0) {
				this.selected = [];
			} else {
				this.selected = this.contactsSliced;
			}
		},

		inProgrammeFilter(contact) {
			return this.inProgramme ? contact.inProgramme == 'Yes' : true;
		},

		inCampFilter(contact) {
			return this.inCamp ? contact.inCamp == 'Yes' : true;
		}
	},

	computed: {
		secondsRemaining() {
			return this.counter;
		},

		disabled() {
			return (
				this.counter != 0 || this.loading || this.selected.length == 0
			);
		},
		message() {
			if (this.loading) {
				return 'Please wait..';
			} else {
				return this.secondsRemaining > 0
					? `Please wait ${this.secondsRemaining} seconds`
					: 'Create New Setup Fees';
			}
		},
		contacts() {
			return Object.values(this.$store.getters.contacts)
				.filter(this.inProgrammeFilter)
				.filter(this.inCampFilter)
				.filter(contact => {
					return contact.setupFeePaid != '1';
				});
		},

		contactsSliced() {
			const count = this.sliceIndex + this.count;

			return this.contacts.slice(this.sliceIndex, count);
		}
	},
	beforeMount() {},

	mounted() {},
	created() {
		this.$store.dispatch('GET_ALL_CONTACTS');
		this.counter = this.countDownTime;
	}
};
</script>

<style scoped>
[v-cloak] {
	display: none;
}
</style>
